import { Code, Flex, Table } from '@mantine/core';
import { useMemo } from 'react';
import { Title } from '../../../components/Title';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { PosMessageDto } from '../types/PosMessageDto';
import { getDaysOfPosMessage } from './PosMessageRow';
import { KeyedRow } from '../../../components/KeyedRow';

export function PosMessageView({ posMessage }: { posMessage: PosMessageDto }) {
	const daysAvailable = useMemo(() => {
		return getDaysOfPosMessage(posMessage);
	}, [posMessage]);

	return (
		<>
			<Table variant="vertical">
				<KeyedRow>
					<Table.Th w={'10vw'}>
						<Title label={'Days'} />
					</Table.Th>
					<Table.Td>
						<Flex
							justify="flex-start"
							align="flex-start"
							direction="row"
							wrap="wrap"
						>
							{daysAvailable.map((d) => {
								return (
									<>
										{/* biome-ignore lint/correctness/useJsxKeyInIterable: <explanation> */}
										<Code my={0} mr={6}>
											{d}
										</Code>
									</>
								);
							})}
						</Flex>
					</Table.Td>
				</KeyedRow>
				<KeyedRow>
					<Table.Th w={'10vw'}>
						<Title label={'POS Message'} />
					</Table.Th>
					<Table.Td>
						<Flex
							justify="flex-start"
							align="flex-start"
							direction="column"
							wrap="wrap"
						>
							{undefinedCheck(posMessage.posMessage)}
						</Flex>
					</Table.Td>
				</KeyedRow>
			</Table>
		</>
	);
}
